import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
// import jsPDF from 'jspdf';
import { connect } from 'react-redux';
import QRCodeImage from 'qrcode.react';
import QRCodePrint from 'react-qr-code';
import { constant } from './Utils/constants';
import translation from './Utils/translation';
import goback from './Utils/images/goback.jpg';
import TableSelect from './Widgets/TableSelect';
import Highlighter from 'react-highlight-words';
import { getScannerId } from './Utils/FormCalls';
import { decode as base64_decode } from 'base-64';
import { API_DEVICE } from '../../../../commons/api';
import InputComponent from './Widgets/InputComponent';
import localStorage from '../../../../utils/localStorage';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { Form, message, Input, Button, Modal } from 'antd';
import { exportComponentAsJPEG } from 'react-component-export-image';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import {
  getSitesList,
  getDeviceList,
  getManufacturerList,
  getHierarchyList,
  submitMaster,
  getQRById
} from './Utils/FormCalls';

// const { Option } = Select;
const urlList = {
  insert: `${API_DEVICE.UpdateScannerId}`,
  getbyId: `${API_DEVICE.GetScannerDetails}`
};
const layout = {
  wrapperCol: {
    offset: 8
  }
};

function QrDetails(props) {
  const [state, setState] = useState({
    value: 0,
    viewQr: false,
    disableQRButton: true,
    formObject: props.formObject || {},
    hierarchyList: [],
    sitesList: [],
    deviceList: [],
    ManufacturerList: [],
    tableData: [],
    searchText: '',
    visible: false,
    emailmodal: false,
    translationCache:props.translationCache || []
  });

  const QrRef = useRef();
  const emailref = useRef();
  const searchInput = useRef(null);
  // const [searchText, setSearchText] = useState('');
  // const picRef = useRef();

  useEffect(() => {
    _getDataById();
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (state.translationCache !== props.translationCache) {
      setState(prevState => ({
        ...prevState,
        translationCache: props.translationCache
      }));
    }
    if (
      props.formObject &&
      Object.keys(props.formObject).length === 0 &&
      Object.keys(state.formObject).length === 0
    ) {
      // onReset();
    }
    if (formObject !== props.formObject) {
      setState(prevState => ({
        ...prevState,
        formObject: props.formObject
      }));
    }
  }, [props.translationCache, props.formObject]);

  const fetchInitialData = async () => {
    try {
      const hierarchyList = await getHierarchyList();
      const sitesList = await getSitesList();
      const deviceList = await getDeviceList();
      const ManufacturerList = await getManufacturerList();

      let formObject = QrRef.current.getFieldsValue();
      formObject = {
        ...formObject,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      QrRef.current.setFieldsValue(formObject);

      setState(prevState => ({
        ...prevState,
        hierarchyList,
        sitesList,
        deviceList,
        ManufacturerList,
        formObject
      }));
    } catch (error) {
      message.warning(`${error.message}`);
    }
  };

  const getDeviceData = (key) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}&Type=Scanner`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
  .then(({ data }) => {
    setState(prevState => {
      return {
        ...prevState,
        tableData: data,
        [key]: true,
        formObject: QrRef.current.getFieldsValue()
      };
    });
  })
  .catch(function () { });
  };

  const TableDropdownChange = async (value, modal) => {
    let formObject = QrRef.current.getFieldsValue();
    let ScannerIdResult = await getScannerId(value.DeviceCode);
    formObject = {
      ...formObject,
      AliasCode: value.AliasCode,
      Description: value.Name,
      Location: value.AssetDisplayCode,
      //AssetDisplayCode:value.AssetDisplayCode,
      LocationDescription: value.LocationDescription,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      ScannerId: ScannerIdResult.ScannerId
    };
    QrRef.current.setFieldsValue(formObject);
    setState(prevState => ({
      ...prevState,
      formObject,
      [modal]: false,
      value: ScannerIdResult.ScannerId
    }));
  };

  const _getDataById = async (QrId) => {
    try {
      let formObject = {};
      let path = props.location.pathname.split('/rubus/QrDetails/');
      let formId = QrId ? QrId : base64_decode(path[1]);
      if (formId !== 'new') {
        let data = await getQRById(urlList.getbyId, formId, 'POST');
        formObject = data && data !== undefined ? data : {};
        setState(prevState => ({
          ...prevState,
          viewQr: true,
          value: formId
        }));
      }
      if (QrRef.current) {
        QrRef.current.setFieldsValue(formObject);
      }

      setState(prevState => ({
        ...prevState,
        formObject,
        datasource: formObject && formObject.Specifications ? formObject.Specifications : []
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const onFormsubmit = async () => {
    let { formObject } = state;
    let payload = {
      ...formObject
    };
    let statusResponse = await submitMaster(urlList.insert, payload);
    if (statusResponse && statusResponse.message) {
      setState(prevState => ({
        ...prevState,
        viewQr: true,
        disableQRButton: true
      }));
      message.success(statusResponse.message);
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const handleError = (error) => {
    console.error(error);
  };

  // const sendEmail = (key) => {
  //   setState(prevState => ({
  //     ...prevState,
  //     [key]: true
  //   }));
  // };

  const emailmodalOk = () => {
    setState(prevState => ({ ...prevState, emailmodal: false }));
  };

  const emailmodalCancel = () => {
    setState(prevState => ({ ...prevState, emailmodal: false }));
  };

  // const downloadQRCodeasPdf = () => {
  //   let pdf = new jsPDF({
  //     orientation: 'landscape',
  //     unit: 'mm',
  //     format: [40, 40]
  //   });
  //   const canvas = document.getElementById('QRIMAGE').toDataURL('image/png');
  //   pdf.addImage(canvas, 'png', 0, 0, 40, 40);
  //   pdf.save(`${state.value}.pdf`);
  // };

  const onModalOk = () => {
    setState(prevState => ({ ...prevState, visible: false }));
  };

  const onDrawerCancel = () => {
    setState(prevState => ({ ...prevState, visible: false }));
  };

  const print = () => {
    const printablecontent = document.getElementById('print').innerHTML;
    const printwindow = window.open('', '_blank', '', '');
    printwindow.document.write(printablecontent);
    printwindow.print();
    printwindow.close();
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setState(prevState => ({ ...prevState, searchText: selectedKeys[0] }));
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
        >
          {translation(props.translationCache, 'Search')}
        </Button>
        <Button onClick={() => handleReset(clearFilters, confirm)} >
          {translation(props.translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: () => (
      <SearchOutlined style={{ color: 'white', }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const resetFields = () => {
    let t1 = {
      DisplayCode: '',
      Description: '',
      Location: undefined,
      LocationDescription: '',
      ScannerId: ''
    };
    if (QrRef.current && QrRef.current !== null) {
      QrRef.current.setFieldsValue({ ...t1 });
      setState(prevState => ({
        ...prevState,
        formObject: {},
        viewQr: false
      }));
    }
  };

  const { formObject, value, viewQr } = state;

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };

  return (
    <>
      <div style={{ color: '#ffb327' }}>
        <span style={{ cursor: 'pointer' }} onClick={() => props.navigate(-1)}>
          <img src={goback} alt="logo" style={{ width: '25px' }} />
        </span>
      </div>
      <Form
        name="basic"
        theme={themeSettings}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 8 }}
        ref={QrRef}
        initialValues={formObject}
        onFinish={onFormsubmit}
        autoComplete="off"
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        validateMessages={validateMessages}
      >
        <Form.Item
          label={translation(props.translationCache, constant.equipment)}
          name="DisplayCode"
          rules={[{ required: true }]}
          disabled={formObject && formObject.Id ? true : false}
        >
          <Input
            disabled={true}
            style={{ color: 'black', background: 'white' }}
            color="black"
            suffix={
              <DownOutlined
                style={{
                  color: '#1a3b5c',
                  cursor: formObject && formObject.Id ? 'not-allowed' : null,
                  opacity: formObject && formObject.Id ? '0.8' : null
                }}
                onClick={(e) => {
                  e.preventDefault();
                  if (formObject && !formObject.Id) {
                    getDeviceData('visible');
                  }
                  setState(prevState => ({
                    ...prevState,
                    disableQRButton: false
                  }));
                }}
              />
            }
            placeholder={translation(props.translationCache, constant.SelectEquipment)}
          />
        </Form.Item>
        <Form.Item
          label={translation(props.translationCache, constant.equipmentDescription)}
          name="Description"
          rules={[{ required: true }]}
        >
          <InputComponent
            // maxLength={150}
            style={{ color: 'black', background: 'white' }}
            placeholder={translation(props.translationCache, constant.AutopopulatebasedonEquipment)}
            disabled={true}
          />
        </Form.Item>
        <Form.Item
          label={translation(props.translationCache, constant.location)}
          name="Location"
          rules={[{ required: true }]}
        >
        
         <InputComponent
            // maxLength={150}
            style={{ color: 'black', background: 'white' }}
            placeholder={translation(props.translationCache, constant.AutopopulatebasedonEquipment)}
            disabled={true}
          />
        </Form.Item>
        <Form.Item
          label={translation(props.translationCache, constant.locationDescription)}
          name="LocationDescription"
          rules={[{ required: true }]}
        >
          <InputComponent
            style={{ color: 'black', background: 'white' }}
            placeholder={translation(
              props.translationCache,
              constant.AutopopulatebasedonEquipment
            )}
            disabled={true}
          // maxLength={150}
          />
        </Form.Item>
        <Form.Item
          label={translation(props.translationCache, constant.scannerId)}
          name="ScannerId"
          rules={[{ required: true }]}
        >
          <InputComponent
            disabled={true}
            style={{ color: 'black', background: 'white' }}
            placeholder={translation(props.translationCache, constant.AutopopulatebasedonEquipment)}
          //   disabled={formObject && formObject.Id ? true : false}
          // onChange={(e) => this.scannerChange(e.target.value)}
          />
        </Form.Item>
        <Form.Item {...layout}>
          <Button htmlType="submit" style={{ backgroundColor: '#d98e04', color: 'black' }}>
            {translation(props.translationCache, constant.GenerateQR)}
          </Button>
          <Button
            htmlType="button"
            style={{ marginLeft: '5px', color: 'black' }}
            onClick={() => resetFields()}
          >
            {translation(props.translationCache, constant.Reset)}
          </Button>
        </Form.Item>
      </Form>
      {viewQr && viewQr === true ? (
        <div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              // id="print123"
              ref={emailref}
              style={{
                height: 340,
                width: 420,
                backgroundColor: 'white'
              }}
            >
              <p style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                {'ScannerId'}:{value}
              </p>

              <QRCodeImage
                id="QRIMAGE"
                style={{ marginLeft: '110px' }}
                value={`${JSON.stringify({ ScannerId: value })}`}
                // delay={this.state.delay}
                // style={previewStyle}
                size={220}
                onError={handleError}
              // onScan={this.handleScan}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '50px',
              marginBottom: '40px'
            }}
          >
            <Button
              type='primary'
              style={{ marginRight: '50px' }}
              onClick={() => exportComponentAsJPEG(emailref)}
            >
              {translation(props.translationCache, constant.SaveImage)}
            </Button>

            <Button
              type='primary'
              style={{ marginRight: '6px' }}
              onClick={print}
            >
              {translation(props.translationCache, constant.PrintImage)}
            </Button>

          </div>
        </div>
      ) : null}
      {
        <div
          id="print"
          style={{
            display: 'flex',
            justifyContent: 'center',
            opacity: 0,
            marginLeft: '950px',
            height: 240,
            width: 320,
            backgroundColor: 'white'
          }}
        >
          <p
            size={400}
            //,
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '180px'
            }}
          >
            {'ScannerId'}:{value}
          </p>
          <QRCodePrint
            display="false"
            id="QRPrint"
            style={{ marginLeft: '120px' }}
            value={`${JSON.stringify({ ScannerId: value })}`}
            // delay={this.state.delay}
            // style={previewStyle}
            size={400}
            onError={handleError}
          // onScan={this.handleScan}
          />
        </div>
      }
      <Modal
        open={state.visible}
        width={800}
        closable
        title={translation(props.translationCache, constant.selectEquipment)}
        okText={translation(props.translationCache, 'Ok')}
        cancelText={translation(props.translationCache, 'Cancel')}
        onOk={onModalOk}
        onCancel={onDrawerCancel}
      >
        <TableSelect
          data={state.tableData}
          translationCache={props.translationCache}
          key="AliasCode"
          columns={[
            {
              title: translation(props.translationCache, 'Equipment'),
              dataIndex: 'DisplayCode',
              key: 'DisplayCode',
              ...getColumnSearchProps('DisplayCode')
            },
            {
              title: translation(props.translationCache, 'Equipment Description'),
              dataIndex: 'Name',
              key: 'Name',
              ...getColumnSearchProps('Name')
            }
          ]}
          handleDropdownChange={(e) => {
            TableDropdownChange(e, 'visible');
        }}
        />
      </Modal>
      <Modal
        open={state.emailmodal}
        width={800}
        closable
        title={translation(props.translationCache, constant.SendEmail)}
        okText={translation(props.translationCache, 'Ok')}
        cancelText={translation(props.translationCache, 'Cancel')}
        onOk={emailmodalOk}
        onCancel={emailmodalCancel}
      >
        <Form.Item
          style={{
            width: '75%'
          }}
          label={translation(props.translationCache, constant.locationDescription)}
          name="LocationDescription"
          rules={[{ required: true }]}
        >
          <InputComponent
            style={{ color: 'black' }}
            placeholder={translation(
              props.translationCache,
              constant.AutopopulatebasedonLocation
            )}
            disabled={true}
          />
        </Form.Item>
      </Modal>
      {/* </Form > */}
    </>
  );
}

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(QrDetails);
